import React, { createContext, useContext, useState, useCallback } from 'react';
import AuthDrawer from '../components/AuthDrawer';

const AuthDrawerContext = createContext(null);

export function useAuthDrawer() {
  const ctx = useContext(AuthDrawerContext);
  if (!ctx) throw new Error('useAuthDrawer must be used inside <AuthDrawerProvider>');
  return ctx;
}

export function AuthDrawerProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState('login');

  const openSignIn = useCallback(() => { setMode('login');    setOpen(true); }, []);
  const openSignUp = useCallback(() => { setMode('register'); setOpen(true); }, []);
  const close      = useCallback(() => setOpen(false), []);

  const value = { open, mode, openSignIn, openSignUp, close, setMode };

  return (
    <AuthDrawerContext.Provider value={value}>
      {children}
      <AuthDrawer
        open={open}
        mode={mode}
        onClose={close}
        onModeChange={setMode}
      />
    </AuthDrawerContext.Provider>
  );
}
